import { apis } from 'src/environments';

export enum AppRoutes {
	HOME = '/home',
	COMPANY_DATA = '/home/company-data',
	OTP = '/home/verify-phone',
	TAX_FOLDER = '/home/tax-folder',
	TAX_FOLDER_WARNING = '/home/tax-folder-warning',
	ERROR = '/error',
}

export const ApiEndpoints = {
	publicSimulatorExp: {
		initialParameters: `${apis.simuladorPublicoPymeExp}/simulador-publico`,
		validate: `${apis.simuladorPublicoPymeExp}/cliente/valida`,
		consent: `${apis.simuladorPublicoPymeExp}/carpeta-tributaria/consentimientos`,
		requestTaxFolder: `${apis.simuladorPublicoPymeExp}/carpeta-tributaria/solicitud`,
		generateSendOtp: `${apis.simuladorPublicoPymeExp}/codigos-otp/generacion-envio`,
		otpValidation: `${apis.simuladorPublicoPymeExp}/codigos-otp/validacion`,
	},
	policiesAndConsentsBff: {
		getPublicPurposes: `${apis.bffNormativoConsentimientos}/obtener-propositos-public`,
		setPublicConsents: `${apis.bffNormativoConsentimientos}/consentimientos-public`,
	},
};
